var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WCAlert',{class:("alert-" + _vm.variant)},[_c('WCAlertCloseButton',{on:{"close":_vm.close}}),_vm._v(" "+_vm._s(this.$t('editOrderSuccess'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }